export type AiProvider = 'OpenAI' | 'OpenAICompatible' | 'Anthropic';

export const AI_PROVIDER_OPEN_AI: AiProvider = 'OpenAI';
export const AI_PROVIDER_OPEN_AI_COMPATIBLE: AiProvider = 'OpenAICompatible';
export const AI_PROVIDER_ANTHROPIC: AiProvider = 'Anthropic';
export const DEFAULT_AI_PROVIDER: AiProvider = AI_PROVIDER_OPEN_AI;

export type AiReasoningEffort =
  'default' | 'none' | 'minimal' | 'low' | 'medium' | 'high' | 'xhigh' | 'max';

export type AiCredential = {
  id: number;
  provider: AiProvider;
  modelId: string;
  apiBaseUrl?: string | null;
  isDefault: boolean;
  hasApiKey: boolean;
  keyLastFour?: string | null;
  hasGitHubPat: boolean;
  gitHubPatLastFour?: string | null;
  gitHubOwner?: string | null;
  additionalInstructions?: string | null;
  reasoningEffort: AiReasoningEffort;
};

export type SaveAiCredentialRequest = {
  id?: number;
  provider: AiProvider;
  modelId: string;
  apiBaseUrl?: string;
  apiKey?: string;
  gitHubPat?: string;
  gitHubOwner?: string;
  additionalInstructions?: string;
  reasoningEffort: AiReasoningEffort;
  isDefault: boolean;
};

export type GitHubDeviceFlowInitiateResponse = {
  device_code: string;
  user_code: string;
  verification_uri: string;
  expires_in: number;
  interval: number;
};

export type GitHubDeviceFlowPollRequest = {
  device_code: string;
};

export type AiImplementationRunStatus =
  'Validating' | 'ValidationFailed' | 'Running' | 'Succeeded' | 'Failed' | 'Cancelled';

export const isTerminalStatus = (
  status: AiImplementationRunStatus | string | undefined | null
): boolean => {
  return (
    status === 'ValidationFailed' ||
    status === 'Succeeded' ||
    status === 'Failed' ||
    status === 'Cancelled'
  );
};

export type AiImplementationRun = {
  runId: string;
  taskId: number;
  initiatorRelationId: number;
  provider: string;
  modelId: string;
  status: AiImplementationRunStatus;
  readinessResultJson?: string | null;
  branchName?: string | null;
  pullRequestUrl?: string | null;
  errorSummary?: string | null;
  createdAtUtc: string;
  startedAtUtc?: string | null;
  finishedAtUtc?: string | null;
  updatedAtUtc: string;
};

export type AiImplementationAvailability = {
  canStart: boolean;
  reason?: string | null;
};

export type AiReadinessResult = {
  ready: boolean;
  issues?: string[];
  recommendations?: string[];
  progressStage?: string;
  progress?: string;
};
